import React from 'react'

const Issues = () => {
  return (
    <div>
      
    </div>
  )
}

export default Issues
